import React from 'react';
import { syncNavigation, saveNavigation, exportNavigation, importNavigation, clearExportUrls, resetErrors } from '../../modules/navigation'
import withRouter from 'with-router'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import ItemsList from '../../components/ItemsList'
import ItemsListSkeleton from '../../components/ItemsListSkeleton'
import LoadingIndicator from '../../components/LoadingIndicator';
import EmptyView from '../../components/EmptyView';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Link from '@mui/material/Link';
import DontAskAgainDialog from '../../components/DontAskAgainDialog.js';
import OptionsMenu from '../../components/OptionsMenu';
import { Trans, withTranslation, useTranslation } from 'react-i18next';
import ExportImportDialogs from '../../components/ExportImportDialogs';
import API from '../../api/api';


// the id the fields hang off, and what onSave reads its pending edits by
const ITEM_ID = 'navigation';

class Navigation extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      data: [],
      showDownloadDialog: true,
      showImportCompleteDialog: false,
      showClearAllNotice: false,
      forceOpenExportDialog: false,
      forceOpenImportDialog: false,
    }
  }

  componentDidMount() {
    this.props.syncNavigation(this.props.editLanguage)

    if(this.props.navigation.export_po_download_url || this.props.navigation.export_csv_download_url) {
      this.setState({showDownloadDialog: false})
    }
  }

  componentWillUnmount() {
    API.clearAllFetches();
  }

  componentWillReceiveProps(newProps) {
    const currentLanguage = this.props.editLanguage;
    const newLanguage = newProps.editLanguage;
    if(currentLanguage != newLanguage) {
      this.props.syncNavigation(newLanguage)
      return
    }

    if(this.props.navigation.import_navigation_pending === true && newProps.navigation.import_navigation_pending === false && !newProps.navigation.error && !newProps.navigation.import_cancelled) {
      this.setState({showImportCompleteDialog: true}, () => {
        this.setState({showImportCompleteDialog: false});
      })
    }

    // A link is a single title, so a collapsible row per link only ever held one field.
    // One wrapping item turns the section into a flat list of those titles
    if(newProps.navigation.links !== this.props.navigation.links) {
      const fields = [];
      for(let key in newProps.navigation.links) {
        const item = newProps.navigation.links[key];
        fields.push({
          id: item.id,
          resource_ids: item.resource_ids,
          source: item.source,
          target: item.target || ''
        })
      }

      this.setState({data: [{
        type: 'navigation',
        id: ITEM_ID,
        title: newProps.t('pages.navigation.title'),
        info: '',
        fields: fields,
      }]});
    }
  }

  fields = () => this.state.data.length > 0 ? this.state.data[0].fields : [];

  usedItem = field => ({
    id: field.id,
    resource_ids: field.resource_ids,
    title: field.target
  })

  onSave = (items, fields) => {
    const item = items.find(x => x.id === ITEM_ID);
    if(!item) {
      return;
    }

    // the wrapping item is selected as a whole, so the pending-edit keys are the only
    // thing that says which links were touched
    const usedItems = item.fields
      .filter(field => fields[`${ITEM_ID}-${field.id}`] || fields[`${ITEM_ID}-${field.id}`] === '')
      .map(this.usedItem);

    this.props.saveNavigation(this.props.editLanguage, usedItems)
  }

  onResaveAll = () => {
    this.props.saveNavigation(this.props.editLanguage, this.fields().map(this.usedItem))
  }

  onClearAll = () => {  
    this.setState({ showClearAllNotice: true });
  }
  clearAll = () => {
    const item = this.state.data[0];
    if(!item) {
      return;
    }
    const cleared = item.fields.map(field => ({...field, target: ''}));

    this.setState({data: [{...item, fields: cleared}]});
    this.props.saveNavigation(this.props.editLanguage, cleared.map(this.usedItem));
  }
  cancelClearAll = () => {
    this.setState({ showClearAllNotice: false });
  }

  onImport = (e) => {
    this.setState({forceOpenImportDialog: true}, () => {
      this.setState({forceOpenImportDialog: false});
    });   
    this.setState({ optionsMenuAnchorEl: null });
  }

  onExport = (e) => {
    this.setState({forceOpenExportDialog: true}, () => {
      this.setState({forceOpenExportDialog: false});
    });   
  }

  onCloseDownloadDialog = () => {
    this.setState({showDownloadDialog: false})
  }

  onCloseImportCompleteDialog = () => {
    window.location.reload();
  }

  render() {
    const { t } = this.props

    if(this.props.navigation.sync_navigation_pending === true || (this.props.navigation.error && this.props.navigation.error.level === 0)) {
      return <React.Fragment>
        <Typography variant="h4" gutterBottom component="h2">
          {t('pages.navigation.title')}
        </Typography>
        <Divider className="divider-white" />
        <ItemsListSkeleton rows="10"/>
        <LoadingIndicator
          pending={this.props.navigation.sync_navigation_pending || this.props.navigation.save_navigation_pending}
          progress={this.props.navigation.progress}
          error={this.props.navigation.error}
        />
      </React.Fragment>  
    }

    return <React.Fragment>
      <Typography variant="h4" gutterBottom component="h2">
        {t('pages.navigation.title')}

        <OptionsMenu
          onImport={this.onImport}
          onExport={this.onExport}
          onClearAll={this.onClearAll}
          onResaveAll={this.onResaveAll}
          shopPlan={this.props.shopPlan}
        />
      </Typography>

      <Divider className="divider-white" />
      {this.fields().length === 0 ?
        <EmptyView
          title={t('pages.navigation.noContent')}
          bottom={<Button href={`https://${this.props.shopUrl}/admin/menus`} target="_blank" variant="contained" color="primary">{t('system.createOneHere')}</Button>}
        />
      :
      <Paper sx={{width: '100%', marginTop: '20px', position: 'relative'}} elevation={1}>
        <ItemsList
          type="navigation"
          showOnlyFieldsList={true}
          clearEditsOnSave={true}
          // one wrapping item, so there is nothing to sort at item level - the fields do sort
          hideSorting={true}
          sortFields={true}
          pagination={false}
          paginate={false}
          isPending={
            this.props.navigation.sync_navigation_pending ||
            this.props.navigation.save_navigation_pending ||
            this.props.navigation.export_navigation_pending ||
            this.props.navigation.import_navigation_pending
          }
          isSaving={
            this.props.navigation.save_navigation_pending
          }
          onSave={this.onSave}
          data={this.state.data}
          allowAutoTranslation={true}
          allowFieldFiltering={true}
          error={this.props.navigation.error}
          errorLockCollapse={this.state.errorLockCollapse}
        />
      </Paper>
      }
      <LoadingIndicator
        pending={this.props.navigation.sync_navigation_pending || this.props.navigation.save_navigation_pending || this.props.navigation.export_navigation_pending || this.props.navigation.import_navigation_pending}
        loadingType={this.props.navigation.save_navigation_pending ? 'saving' : 'loading'}
        progress={this.props.navigation.progress}
        error={this.props.navigation.error}
        onErrorCancel={this.props.resetErrors}
        onErrorRetry={() => {
          this.setState({ errorLockCollapse: true }, () => {
            this.setState({ errorLockCollapse: false });
          });
        }}
      />

      <ExportImportDialogs
        //showDownloadDialog={this.state.showDownloadDialog}
        showImportCompleteDialog={this.state.showImportCompleteDialog}
        imported_entries={this.props.navigation.imported_entries}
        export_po_download_url={this.props.navigation.export_po_download_url}
        export_csv_download_url={this.props.navigation.export_csv_download_url}
        forceOpenExportDialog={this.state.forceOpenExportDialog}
        forceOpenImportDialog={this.state.forceOpenImportDialog}
        exportFunc={(options) => { this.props.exportNavigation(this.props.editLanguage, options) }}
        importFunc={(formData, fileType, options) => { this.props.importNavigation(formData, fileType, this.props.editLanguage) }}
        syncFunc={() => { this.props.syncNavigation(this.props.editLanguage)}}
        clearFunc={this.props.clearExportUrls}
        pending={this.props.navigation.export_navigation_pending}
        scope={'navigation'}
        additionalFields={['with_BOM']}
      />

      <DontAskAgainDialog
        context="ClearAllTranslations"
        open={this.state.showClearAllNotice}
        onClose={this.cancelClearAll}
        onCancel={this.cancelClearAll}
        onSubmit={this.clearAll}
        title="Really clear all translations?"
        content="This action will clear all translations and can't be un-done."
        initialChecked={false}
      />
    </React.Fragment> 
  }
}

const mapStateToProps = ({ navigation, shop }) => ({
  navigation: navigation,
  editLanguage: shop.shop.edit_language,
  shopPlan: shop.shop.charge.name,
  shopUrl: shop.shop.url,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      syncNavigation,
      saveNavigation,
      exportNavigation,
      importNavigation,
      resetErrors,
      clearExportUrls
    },
    dispatch
  )

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Navigation)))